import {Injectable} from '@angular/core';
import {affectedLotLayerDefinition} from './affected-layer-definition';
import {angleLayerDefinition} from './angle-layer-definition';
import {annotationLayerDefinition} from './annotation-layer-definition';
import {clippingLayerDefinition} from './clipping-layer-definition';
import {constructLineLayerDefinition} from './constructline-layer-definition';
import {constructPointLayerDefinition} from './constructpoint-layer-definition';
import {pointLayerDefinition} from './point-layer-definition';
import {enlargementLayerDefinition} from './enlargement-layer-definition';
import {interestLayerDefinition} from './interest-layer-definition';
import {lineLayerDefinition} from './line-layer-definition';
import {lotLayerDefinition} from './lot-layer-definition';
import {polygonLayerDefinition} from './polygon-layer-definition';
import {printAreaLayerDefinition} from './printarea-layer-definition';
import {roadLayerDefinition} from './road-layer-definition';

@Injectable({
    providedIn: 'root'
})
export class LayerDefinitionService {
    constructor() {}

    getLayerDefinition(featureClass: string): any {
        console.log(`LayerDefinitionService getLayerDefinition ${featureClass}`);
        switch (featureClass) {
            case 'affectedlot':
                return affectedLotLayerDefinition;
            case 'angle':
                return angleLayerDefinition;
            case 'annotation':
                return annotationLayerDefinition;
            case 'clipping':
                return clippingLayerDefinition;
            case 'constructline':
                return constructLineLayerDefinition;
            case 'constructpoint':
                return constructPointLayerDefinition;
            case 'controlpoint':
                return pointLayerDefinition;
            case 'enlargement':
                return enlargementLayerDefinition;
            case 'interest':
                return interestLayerDefinition;
            case 'line':
                return lineLayerDefinition;
            case 'lot':
                return lotLayerDefinition;
            case 'point':
                return pointLayerDefinition;
            case 'polygon':
                return polygonLayerDefinition;
            case 'polyline':
                return lineLayerDefinition;
            case 'printarea':
                return printAreaLayerDefinition;
            case 'road':
                return roadLayerDefinition;
            default:
                return null;
        }
    }

    getFields(featureClass: string): any[] {
        const layerDefinition = this.getLayerDefinition(featureClass);
        return layerDefinition ? layerDefinition.fields : [];
    }

    getFieldNames(featureClass: string): string[] {
        return this.getFields(featureClass).map(field => field.name);
    }
}
